<div class="flex flex-row items-center lg:w-[250px]">
  @if (['starting', 'progress'].includes(status)) {
    <div class="w-6">
      <gx-loader />
    </div>
  }

  @if (!['starting', 'progress'].includes(status)) {
    <div class="w-6">&nbsp;</div>
  } @else if (status === 'starting') {
    <div class="hidden lg:flex">{{ 'download_starting' | translate }}</div>
  } @else if (status === 'progress') {
    <div class="hidden lg:flex">{{ 'download_progress' | translate: { progress } }}</div>
  } @else if (status === 'completed') {
    <div class="hidden lg:flex">{{ 'download_complete' | translate }}</div>
  }
</div>
